<template>
  <section>
    <header-row :page="page"/>
    <two-column-row
      v-for="(item, index) in page.template.blocks"
      :key="item.title"
      :item="item"
      :index="index"
    />
    <configuration-row :page="page"/>
  </section>
</template>

<script>
import page from '~/plugins/mixins/page';
import ConfigurationRow from '~/components/ConfigurationRow';
import HeaderRow from '~/components/stijlen/HeaderRow';
import TwoColumnRow from '~/components/TwoColumnRow';

export default {
  components: {
    ConfigurationRow,
    HeaderRow,
    TwoColumnRow,
  },
  mixins: [page],
};
</script>
